import request from './request'

export const getWechatConfig = (params) => {
  return request({
    url: '/weChat/noncestr/timestamp/bySource',
    params,
  })
}
